import clsx from 'clsx';
import { useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ChevronDownIcon } from '../../../../../shared/ui/icons';
import selectStyles from '../../../../../shared/ui/select/Select.module.css';
import { useDropdownMenu } from '../../../../../shared/hooks';
import {
  selectTemplatesOrdering,
  templatesOrderingChanged,
} from '../../../../../features/templates/store/templatesSlice';
import styles from '../TemplatesList.module.css';
import { SortCaption } from './SortCaption';
import { SORT_OPTIONS } from '../constants/sortOptions';

export function TemplatesSortRow() {
  const dispatch = useDispatch();
  const ordering = useSelector(selectTemplatesOrdering);

  const buttonRef = useRef(null);
  const { rootRef, open, toggleOpen, close } = useDropdownMenu({ focusRef: buttonRef });
  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  const selected = useMemo(
    () => SORT_OPTIONS.find((o) => o.value === ordering) ?? SORT_OPTIONS[2],
    [ordering],
  );

  return (
    <div ref={rootRef} className={clsx(styles.sortRow)} aria-label="Sort">
      <span className={clsx(styles.sortLabel)}>Sort by:</span>
      <div className={clsx(styles.sortTriggerWrap)}>
        <button
          ref={buttonRef}
          type="button"
          className={clsx(styles.sortTriggerButton)}
          aria-label="Open sort menu"
          aria-haspopup="listbox"
          aria-expanded={open}
          onClick={toggleOpen}
        >
          <span className={clsx(styles.sortSelectValue)}>
            <SortCaption option={selected} />
          </span>
          <ChevronDownIcon
            className={clsx(styles.sortSelectChevron, open && styles.sortChevronOpen)}
            aria-hidden
          />
        </button>

        {open ? (
          <ul
            className={clsx(selectStyles.menu, styles.sortSelectMenu)}
            role="listbox"
            aria-label="Sort"
          >
            {SORT_OPTIONS.map((opt, index) => {
              const isSelected = opt.value === ordering;
              const isHighlighted = index === highlightedIndex;
              return (
                <li
                  key={opt.value}
                  role="option"
                  aria-selected={isSelected}
                  className={clsx(
                    selectStyles.option,
                    styles.sortOption,
                    isSelected && selectStyles.optionSelected,
                    isHighlighted && selectStyles.optionHighlighted,
                  )}
                  onMouseEnter={() => setHighlightedIndex(index)}
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => {
                    if (opt.value === ordering) {
                      close();
                      return;
                    }
                    dispatch(templatesOrderingChanged(opt.value));
                    close();
                  }}
                >
                  <span className={clsx(styles.sortOptionLabel)}>
                    <SortCaption option={opt} />
                  </span>
                </li>
              );
            })}
          </ul>
        ) : null}
      </div>
    </div>
  );
}
